import React from "react";

import Image from "../../components/image";
import ApplyButton from "../../components/shared/applyButton";
import { Link } from "../../utils/customLink";

const MainBlogCard = ({
  title,
  link,
  postImage,
  blurb,
  author,
  date,
  ctaViewLabel = "Read the article",
  cardClickable = false
}) => {
  return (
    <div className="relative w-full mb-4 gvi-program-card-box">
      {cardClickable && (
        <Link
          to={link}
          className={
            "faux-clickable-area bg-transparent absolute top-0 left-0 right-0 bottom-0 z-10 block"
          }
          title={""}
        />
      )}
      <div
        className={`card-holder rounded-xs hover:rounded-none flex flex-col sm:flex-row sm:h-full drop-shadow-lg ${cardClickable ? "cursor-pointer" : ""}`}
      >
        <div className="w-full sm:w-3/12 relative">
          <Image
            imageClass="sm:absolute top-0 left-0 right-0 bottom-0 object-cover object-center w-full rounded-md h-full rounded-b-none md:rounded-l-md md:rounded-r-none"
            sourceUrl={postImage}
            image={""}
            imageAlt=""
          />
        </div>
        <div className="flex flex-col items-start h-full gap-4 px-4 md:px-6 bg-white planet:bg-gray-darker rounded-b w-full sm:w-9/12 py-6 md:py-8">
          <div className="w-full">
            <div
              className="text-[19px] md:text-xl leading-6 font-alice planet:font-body text-left text-black-lighter planet:text-white"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div
              className="text-mob md:text-sm leading-6 font-normal text-left text-black-lighter planet:text-gray-generic pt-4 sm:pt-2 line-clamp-4 sm:line-clamp-2"
              dangerouslySetInnerHTML={{ __html: blurb }}
            />
          </div>

          <div className="flex w-full pt-2">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-6">
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  className="w-5 h-5 stroke-black-lighter planet:stroke-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                  />
                </svg>

                <div
                  className="text-black-lighter planet:text-gray-generic text-sm font-normal text-left pl-1"
                  dangerouslySetInnerHTML={{ __html: author }}
                />
              </div>
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  className="w-5 h-5 stroke-black-lighter planet:stroke-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
                  />
                </svg>
                <div
                  className="text-black-lighter planet:text-gray-generic text-sm font-normal text-left pl-1"
                  dangerouslySetInnerHTML={{ __html: date }}
                />
              </div>
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  className="w-5 h-5 stroke-black-lighter planet:stroke-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <div
                  className="text-black-lighter planet:text-gray-generic text-sm font-normal text-left pl-1"
                  dangerouslySetInnerHTML={{ __html: "6 minute read" }}
                />
              </div>
            </div>
          </div>

          <div className="md:block w-full md:w-2/5 min-w-[10rem] pt-4">
            <div className="flex">
              <ApplyButton
                to={link}
                buttonStyle="group w-full relative z-10 flex flex-row items-center justify-center px-2 py-2 rounded-full planet:rounded-sm bg-transparent text-black-lighter planet:text-white border-2 border-black-lighter planet:border-white planet:hover:bg-white"
                ctaLabel={ctaViewLabel}
                labelClass="text-base font-normal planet:text-white pr-2 planet:group-hover:text-gray-darkest"
                arrowClass="stroke-black-lighter hover:stroke-black-lighter planet:stroke-white planet:group-hover:stroke-gray-darkest"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBlogCard;
